export default __webpack_public_path__ + "static/icomoon-289308cc7f23e64b057a28844873acc0.woff";